import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../components/ui';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-brand-100 mb-6">
          <Icon.Search className="h-8 w-8 text-brand-700" />
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Seite nicht gefunden</h2>
        <p className="text-gray-600 mb-8">
          Die gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center px-6 py-3 bg-brand-600 text-white font-medium rounded-lg hover:bg-brand-700 transition-colors"
        >
          Zurück zum Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
